"use client";
import React, { useState } from "react";
import { formatDate } from "../../../lib/formatDate";
import { Card } from "./components/Listing";
import CardGrid from "../../CardGrid";
import { CommentType } from "../../constants/mockPosts";
import Comment from "./components/Comment";
// import Link from "next/link";
import {
  FacebookIcon,
  TikTokIcon,
  TwitterIcon,
  LinkedinIcon,
  YoutubeIcon,
  InstagramIcon,
} from "../../Icon";

export const socialMediaLinks = [
  { name: "Facebook", icon: <FacebookIcon />, url: "https://facebook.com" },
  { name: "LinkedIn", icon: <LinkedinIcon />, url: "https://linkedin.com" },
  { name: "Instagram", icon: <InstagramIcon />, url: "https://instagram.com" },
  { name: "Twitter", icon: <TwitterIcon />, url: "https://twitter.com" },
  { name: "Youtube", icon: <YoutubeIcon />, url: "https://youtube.com" },
  { name: "TikTok", icon: <TikTokIcon />, url: "https://tiktok.com" },
];

import Breadcrumbs from "./components/BreadCrumb";
import AnnouncementSection from "./components/Announcement";
import { Post, PropertyType } from "src/types";
import { handleShareClick } from "../../constants/helperClient";
import PostMediaCarousel from "./components/PostMediaCarousel";
import CustomSelect from "./components/ui/form/CustomSelect";
const AnnouncementPostPage1 = ({
  post,
  listings,
}: {
  post: Post;
  listings: PropertyType[];
}) => {
  return (
    <section className="py-14">
      <div className="wrapper">
        <Breadcrumbs />
        <div className="grid-container">
          <FirstCol mockPost={post} />
          <SecondCol properties={listings} />
        </div>
        <div className="">
          <AnnouncementSection
            className="-ml-10"
            header={<h3 className="mb-4 ">Related Posts</h3>}
            arr={post.similar}
          />
        </div>
      </div>
    </section>
  );
};
export default AnnouncementPostPage1;

const FirstCol = ({ mockPost }: { mockPost: Post }) => {
  return (
    <div>
      <h1>{mockPost.title}</h1>
      <div className="text-themeColor mb-2 justify-between xs:flex-col xs:items-start items-center mt-5 flex">
        <span className="flex gap-2 items-center">
          <PersonIcon />{" "}
          <span className="text-secondary-main capitalize">
            {mockPost.author.name}
          </span>
        </span>

        <div className="group flex gap-2">
          <div className="likes flex gap-1">
            <LikeIcon />
            <span className="text-themeColor">{mockPost.likes}</span>
            <span className="text-secondary-main">Likes</span>
          </div>
          <div className="dislikes flex gap-1">
            <DislikeIcon />
            <span>{mockPost.dislikes}</span>
            <span className="text-secondary-main">Dislikes</span>
          </div>
          <span>{formatDate(mockPost.date)}</span>
        </div>
      </div>
      <div className=" w-full">
        <PostMediaCarousel post={mockPost} />
      </div>
      <div className="content mb-14 mt-8">
        <div
          className="flex flex-col gap-2"
          dangerouslySetInnerHTML={{ __html: mockPost.content }}
        />
      </div>
      <div className="share  mb-8">
        <h5 className="font-medium text-secondary">Share This Post:</h5>
        <div className="icons mt-4 flex items-center gap-2">
          {socialMediaLinks.map(({ icon, name }, index) => (
            <button
              key={index}
              onClick={() => handleShareClick(name)}
              className="rounded-full border border-themeColor size-10 grid place-items-center cursor-pointer"
              aria-label={`Share on ${name}`}
              type="button"
            >
              {icon}
            </button>
          ))}
        </div>
      </div>
      <CommentsList comments={mockPost.comments} />
    </div>
  );
};
const SecondCol = ({ properties }: { properties: PropertyType[] }) => {
  const isDemoMode = process.env.NEXT_PUBLIC_DEMO_MODE === "true";

  // Options for select
  const demoOptions = [
    { value: "rent", label: "Rent" },
    { value: "sale", label: "Sale" },
    { value: "shortlet", label: "Shortlet" },
  ];

  const [selected, setSelected] = useState<string | null>(null);

  const nonDemoOptions = [{ value: "rent", label: "Rent" }];
  if (properties.length === 0) {
    return <div>No properties available</div>;
  }
  return (
    <div
      style={{
        height: "700px !important",
      }}
      className="bg-white  rounded-xl pt-0 child !h-[800px] shadow-md p-6"
    >
      <div className="item sticky top-0 z-[100] pt-6 bg-white flex justify-between">
        <h4 className="text-secondary-main font-semibold mb-4">
          Recent Listings
        </h4>

        <div className="filter rounded-md h-max p-2 border border-themeColor">
          <CustomSelect
            options={isDemoMode ? demoOptions : nonDemoOptions}
            value={selected}
            onChange={(val) => setSelected(val)}
            placeholder="Select"
            align="right"
          />
        </div>
      </div>

      <CardGrid maxColumns={1}>
        {properties.map((item, index) => {
          return <Card key={index} {...item} />;
        })}
      </CardGrid>
    </div>
  );
};
const PersonIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4C13.0609 4 14.0783 4.42143 14.8284 5.17157C15.5786 5.92172 16 6.93913 16 8C16 9.06087 15.5786 10.0783 14.8284 10.8284C14.0783 11.5786 13.0609 12 12 12C10.9391 12 9.92172 11.5786 9.17157 10.8284C8.42143 10.0783 8 9.06087 8 8C8 6.93913 8.42143 5.92172 9.17157 5.17157C9.92172 4.42143 10.9391 4 12 4ZM12 14C16.42 14 20 15.79 20 18V20H4V18C4 15.79 7.58 14 12 14Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
const LikeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 10L14.014 9.836C13.9902 9.97919 13.9978 10.1259 14.0364 10.2658C14.075 10.4057 14.1436 10.5356 14.2374 10.6464C14.3312 10.7571 14.4481 10.8461 14.5797 10.9072C14.7114 10.9683 14.8548 10.9999 15 11V10ZM4 10V9C3.73478 9 3.48043 9.10536 3.29289 9.29289C3.10536 9.48043 3 9.73478 3 10H4ZM6 21H17.36V19H6V21ZM18.56 9H15V11H18.56V9ZM15.987 10.164L16.792 5.329L14.82 5L14.014 9.836L15.987 10.164ZM14.82 3H14.606V5H14.82V3ZM11.277 4.781L8.762 8.555L10.426 9.665L12.942 5.891L11.277 4.781ZM7.93 9H4V11H7.93V9ZM3 10V18H5V10H3ZM20.302 18.588L21.502 12.588L19.542 12.196L18.342 18.196L20.302 18.588ZM8.762 8.555C8.67065 8.69192 8.54692 8.80417 8.40178 8.88179C8.25665 8.95942 8.09459 9.00002 7.93 9V11C8.42387 11 8.91009 10.878 9.3455 10.6449C9.78092 10.4119 10.1521 10.0749 10.426 9.664L8.762 8.555ZM16.792 5.329C16.8398 5.04254 16.8246 4.74911 16.7475 4.46911C16.6704 4.18911 16.5333 3.92926 16.3456 3.70762C16.1579 3.48598 15.9242 3.30787 15.6608 3.18567C15.3973 3.06347 15.1104 3.00011 14.82 3V5L16.792 5.329ZM18.56 11C18.708 10.9999 18.8541 11.0327 18.9879 11.096C19.1217 11.1592 19.2397 11.2514 19.3336 11.3658C19.4274 11.4802 19.4947 11.614 19.5306 11.7576C19.5664 11.9012 19.571 12.0509 19.542 12.196L21.502 12.588C21.589 12.1528 21.5783 11.7038 21.4708 11.2733C21.3633 10.8427 21.1617 10.4414 20.8804 10.0982C20.599 9.75501 20.2451 9.4785 19.844 9.28859C19.443 9.09869 19.0048 9.00012 18.561 9L18.56 11ZM17.36 21C18.0536 21 18.7258 20.7597 19.2622 20.32C19.7986 19.8802 20.166 19.2682 20.302 18.588L18.342 18.196C18.2966 18.4229 18.174 18.6271 17.9949 18.7737C17.8158 18.9204 17.5914 19.0003 17.36 19V21ZM14.606 3C13.9475 3.00001 13.2993 3.16257 12.7187 3.47326C12.1382 3.78395 11.6423 4.23315 11.277 4.781L12.942 5.891C13.1246 5.61698 13.372 5.39228 13.6623 5.23685C13.9526 5.08142 14.2767 5.00006 14.606 5V3ZM6 19C5.73478 19 5.48043 18.8946 5.29289 18.7071C5.10536 18.5196 5 18.2652 5 18H3C3 18.7956 3.31607 19.5587 3.87868 20.1213C4.44129 20.6839 5.20435 21 6 21V19Z"
        fill="var(--primary-color)"
      />
      <path d="M8 10V20" stroke="var(--primary-color)" stroke-width="2" />
    </svg>
  );
};
const DislikeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 14L9.986 14.164C10.0098 14.0208 10.0022 13.8741 9.96357 13.7342C9.92499 13.5943 9.8564 13.4644 9.76258 13.3536C9.66875 13.2429 9.55194 13.1539 9.42025 13.0928C9.28856 13.0317 9.14516 13.0001 9 13V14ZM20 14V15C20.2652 15 20.5196 14.8946 20.7071 14.7071C20.8946 14.5196 21 14.2652 21 14H20ZM18 3H6.64V5H18V3ZM5.44 15H9V13H5.44V15ZM8.013 13.836L7.208 18.671L9.18 19L9.986 14.164L8.013 13.836ZM9.18 21H9.394V19H9.18V21ZM12.723 19.219L15.238 15.445L13.574 14.335L11.058 18.109L12.723 19.219ZM16.07 15H20V13H16.07V15ZM21 14V6H19V14H21ZM3.698 5.412L2.498 11.412L4.458 11.804L5.658 5.804L3.698 5.412ZM15.238 15.445C15.3293 15.3081 15.4531 15.1958 15.5982 15.1182C15.7434 15.0406 15.9054 15 16.07 15V13C15.5761 13 15.0899 13.122 14.6545 13.3551C14.2191 13.5881 13.8479 13.9251 13.574 14.336L15.238 15.445ZM7.208 18.671C7.16023 18.9575 7.17541 19.2509 7.2525 19.5309C7.32959 19.8109 7.46674 20.0707 7.6544 20.2924C7.84207 20.514 8.07575 20.6921 8.33921 20.8143C8.60267 20.9365 8.88958 20.9999 9.18 21V19L7.208 18.671ZM5.44 13C5.29202 13.0001 5.14588 12.9673 5.01211 12.904C4.87834 12.8408 4.76027 12.7486 4.66643 12.6342C4.57258 12.5198 4.5053 12.386 4.46943 12.2424C4.43356 12.0988 4.429 11.9491 4.458 11.804L2.498 11.412C2.41102 11.8472 2.42167 12.2962 2.52916 12.7267C2.63666 13.1573 2.83833 13.5586 3.11964 13.9018C3.40095 14.245 3.7549 14.5215 4.15597 14.7114C4.55704 14.9013 4.99524 14.9999 5.439 15L5.44 13ZM6.64 3C5.94638 2.99996 5.27417 3.24026 4.73778 3.68003C4.20139 4.11979 3.83395 4.73183 3.698 5.412L5.658 5.804C5.70336 5.57705 5.82604 5.37287 6.00511 5.22625C6.18418 5.07964 6.40856 4.99968 6.64 5V3ZM9.394 21C10.0525 21 10.7007 20.8374 11.2813 20.5267C11.8618 20.2161 12.3577 19.7668 12.723 19.219L11.058 18.109C10.8754 18.383 10.628 18.6077 10.3377 18.7631C10.0474 18.9186 9.72328 18.9999 9.394 19V21ZM18 5C18.2652 5 18.5196 5.10536 18.7071 5.29289C18.8946 5.48043 19 5.73478 19 6H21C21 5.20435 20.6839 4.44129 20.1213 3.87868C19.5587 3.31607 18.7956 3 18 3V5Z"
        fill="var(--primary-color)"
      />
      <path d="M16 14V4" stroke="var(--primary-color)" stroke-width="2" />
    </svg>
  );
};
const CommentsList = ({ comments }: { comments: CommentType[] }) => {
  return (
    <div className=" p-4">
      <div className="flex text-xl pb-4 border-b border-disabled-main/50 font-semibold gap-2">
        <span>{comments.length}</span>
        Comments
      </div>
      {comments.length > 0 ? (
        comments.map((comment) => (
          <div
            key={comment.id}
            className=" pb-3 mb-4 border-b border-b-label-main/50"
          >
            <Comment comment={comment} />
          </div>
        ))
      ) : (
        <p className="text-gray-500">No comments yet.</p>
      )}
    </div>
  );
};
